"use strict"; // Copyright 2020 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var _regeneratorRuntime = require("/home/runner/work/liftit-co/liftit-co/build/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/home/runner/work/liftit-co/liftit-co/build/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/runner/work/liftit-co/liftit-co/build/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/liftit-co/liftit-co/build/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/runner/work/liftit-co/liftit-co/build/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/runner/work/liftit-co/liftit-co/build/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/liftit-co/liftit-co/build/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IdTokenClient = void 0;

var oauth2client_1 = require("./oauth2client");

var IdTokenClient = /*#__PURE__*/function (_oauth2client_1$OAuth) {
  _inherits(IdTokenClient, _oauth2client_1$OAuth);

  var _super = _createSuper(IdTokenClient);

  /**
   * Google ID Token client
   *
   * Retrieve access token from the metadata server.
   * See: https://developers.google.com/compute/docs/authentication
   */
  function IdTokenClient(options) {
    var _this;

    _classCallCheck(this, IdTokenClient);

    _this = _super.call(this);
    _this.targetAudience = options.targetAudience;
    _this.idTokenProvider = options.idTokenProvider;
    return _this;
  }

  _createClass(IdTokenClient, [{
    key: "getRequestMetadataAsync",
    value: function () {
      var _getRequestMetadataAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee( // eslint-disable-next-line @typescript-eslint/no-unused-vars
      url) {
        var idToken, headers;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.credentials.id_token || (this.credentials.expiry_date || 0) < Date.now())) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return this.idTokenProvider.fetchIdToken(this.targetAudience);

              case 3:
                idToken = _context.sent;
                this.credentials = {
                  id_token: idToken,
                  expiry_date: this.getIdTokenExpiryDate(idToken)
                };

              case 5:
                headers = {
                  Authorization: 'Bearer ' + this.credentials.id_token
                };
                return _context.abrupt("return", {
                  headers: headers
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getRequestMetadataAsync(_x) {
        return _getRequestMetadataAsync.apply(this, arguments);
      }

      return getRequestMetadataAsync;
    }()
  }, {
    key: "getIdTokenExpiryDate",
    value: function getIdTokenExpiryDate(idToken) {
      var payloadB64 = idToken.split('.')[1];

      if (payloadB64) {
        var payload = JSON.parse(Buffer.from(payloadB64, 'base64').toString('ascii'));
        return payload.exp * 1000;
      }
    }
  }]);

  return IdTokenClient;
}(oauth2client_1.OAuth2Client);

exports.IdTokenClient = IdTokenClient;